<template>
<div style="width:100%;height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="showUnavailable">{{ $t('gateway.no_gateway_available' )}}</span>

  <route-chart v-if="showChart" :mac="selectedGateway" :optimize="isOptimized" :level="edgeLevel" :eventlog="eventlog" style="position:absolute;width:100%;height:100%"></route-chart>

  <route-panel v-if="showPanel" :mac.sync="selectedGateway" :optimize.sync="isOptimized" :level.sync="edgeLevel" :refreshing="isRefreshing" @refresh="refresh" style="position:absolute;width:100%;bottom:0px"></route-panel>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</div>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import RouteAnalysisChart from './RouteAnalysisChart'
import RouteAnalysisPanel from './RouteAnalysisPanel'

export default {
  name: 'RouteAnalysis',
  mixins: [UserAuth],
  components: {
    'route-chart': RouteAnalysisChart,
    'route-panel': RouteAnalysisPanel
  },
  data() {
    return {
      selectedGateway: null,
      eventlog: {},
      isOptimized: false,
      edgeLevel: 1,
      isRefreshing: false
    }
  },
  watch: {
    isOptimized(val) {
      this.edgeLevel = 1;
    },
    selectedGateway(val) {
      this.isRefreshing = false;
    }
  },
  computed: {
    loading() {
      return this.macInfoLoading;
    },
    gatewayList() {
      return Object.values(this.userMacInfo);
    },
    showUnavailable() {
      return !this.loading && this.gatewayList.length == 0;
    },
    showChart() {
      return !this.loading && this.selectedGateway && this.gatewayList.length > 0;
    },
    showPanel() {
      return !this.loading && this.gatewayList.length > 0;
    }
  },
  methods: {
    async refresh() {
      this.isOptimized = false;
      this.isRefreshing = true;
      this.timeToIgnore = new Date().getTime();
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: this.selectedGateway,
          cmd: 'txstatus'
        });
      } catch (err) {
        this.$emit('toast', this.$t('route.permission_denied'));
        return;
      }
      this.$emit('toast', this.$t('route.tx_status_refreshing', {
        mac: (this.userMacInfo[this.mac] || {}).hostname || this.mac
      }));

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) this.$emit('toast', val);
      });

      setTimeout(() => {
        refErr.off();
        this.isRefreshing = false;
      }, 5000);
    }
  },
  mounted() {
    this.$bindAsObject('eventlog', this.$db.ref('userEvent').child(this.userId));
  },
  beforeDestroy() {
    this.$db.ref('userEvent').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/juice/RouteAnalysis.vue